import 'css-chunksrc/client/scenes/workloads/calendar/dailyMonths/month/styles.scss';export default {
  "month": "_month_ty6et_1",
  "year": "_year_ty6et_17"
};